// React
import React from 'react';
import { ADGMImage, ADGMPanel } from 'aurora-components';
import Button from '@material-ui/core/Button';
// utils
import PropTypes from 'prop-types';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { keyEmptyCheck } from 'aurora-utils/utils';

import { Box, Typography } from '@material-ui/core';
import DeleteConditionModal from './Modals/DeleteConditionModal';
import AddConditionModal from './Modals/AddConditionModal';
import styles from './styles';
import ConditionsView from './ConditionsView';

const ADGMAppendix = ({
  classes,
  data,
  isEditable,
  handleEditSpecialCondition,
  handleDelete,
  sectionFields,
  toggleModal,
  openAddSpecialConditionModal,
  selectedCondition,
  handleSubmit,
  openDeleteSpecialConditionModal,
  handleResetDeleteSpecialCondition,
  handleSubmitDeleteSpecialCondition,
}) => {
  if (!isEditable && data && data?.length < 1) return null;
  return (
    <>
      <ADGMPanel
        hasPadding={false}
        title={keyEmptyCheck('appendix')}
        subtitle={isEditable && keyEmptyCheck('terms_and_conditions_hint')}
        handleRightTitle={
          isEditable && data?.length > 0 ? (
            <div className={classes.upload}>
              <svg width='13' height='13' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g clipPath='url(#clip0_2141_14903)'>
                  <path
                    d='M7.76017 6.65073L10.5411 3.86887L10.5621 17.5003C10.5621 18.3287 11.2336 19.0002 12.062 19.0002C12.8904 19.0002 13.5619 18.3287 13.5619 17.5003L13.5409 3.88588L16.3058 6.65078C16.8813 7.24663 17.8309 7.26313 18.4267 6.68762C19.0226 6.11211 19.0391 5.16256 18.4636 4.56671C18.4515 4.5542 18.4392 4.54192 18.4267 4.52987L15.2149 1.31799C13.4576 -0.439323 10.6085 -0.439323 8.85114 1.31795L8.8511 1.31799L5.63927 4.52982C5.06376 5.12567 5.08026 6.07523 5.67611 6.65073C6.25738 7.21213 7.1789 7.21213 7.76017 6.65073Z'
                    fill='black'
                  />
                  <path
                    d='M22.4995 14.5005C21.6711 14.5005 20.9996 15.172 20.9996 16.0004V20.5912C20.999 20.8169 20.8163 20.9997 20.5906 21.0002H3.40933C3.18368 20.9996 3.00087 20.8169 3.00036 20.5912V16.0004C3.00036 15.172 2.32881 14.5005 1.50042 14.5005C0.672038 14.5005 0.000488281 15.172 0.000488281 16.0004V20.5912C0.00269131 22.473 1.52761 23.9978 3.40933 24H20.5906C22.4723 23.9978 23.9972 22.4729 23.9994 20.5912V16.0004C23.9995 15.172 23.3279 14.5005 22.4995 14.5005Z'
                    fill='black'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_2141_14903'>
                    <rect width='24' height='24' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              {keyEmptyCheck('add_a_term')}
            </div>
          ) : null
        }
        handleRightButton={isEditable && toggleModal}
        classes={{ titleHead: classes.titleHead }}
      >
        {/* {isEditable && (
        <div className={classes.topBar}>
          <ADGMAlert visible type='info' customClasses={{ container: classes.infoPanel }}>
            <FormattedMessage {...messages.terms_and_conditions_hint} />
          </ADGMAlert>
          <Button variant='outlined' className={classes.addBtnContent} size='large' onClick={toggleModal}>
            <ADGMImage name='plusIconBlack.svg' alt='icon' /> {keyEmptyCheck('add_a_term')}
          </Button>
        </div>
      )} */}
        {isEditable && data?.length === 0 && (
          <Box
            sx={{
              border: '1px dashed #828488',
              padding: '80px 56px',
              textAlign: 'center',
              background: '#fff',
            }}
          >
            <div>
              <Typography className={classes.emptyHeading}>{keyEmptyCheck('no_terms_add')}</Typography>
              <Button variant='outlined' className={classes.addBtnContent} size='large' onClick={toggleModal}>
                <ADGMImage width='16px' name='uploadImg.svg' alt='icon' /> {keyEmptyCheck('add_a_term')}
              </Button>
            </div>
          </Box>
        )}
        <ConditionsView
          data={data}
          isEditable={isEditable}
          onEdit={handleEditSpecialCondition}
          onDelete={handleDelete}
        />
        <AddConditionModal
          openModal={openAddSpecialConditionModal}
          loading={false}
          selectedCondition={selectedCondition}
          toggleModal={toggleModal}
          sectionFields={sectionFields}
          handleSubmit={handleSubmit}
        />
        <DeleteConditionModal
          isOpen={openDeleteSpecialConditionModal}
          handleClose={handleResetDeleteSpecialCondition}
          handleSubmit={handleSubmitDeleteSpecialCondition}
          selectedCondition={selectedCondition}
        />
      </ADGMPanel>
    </>
  );
};
ADGMAppendix.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  handleEditSpecialCondition: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
  sectionFields: PropTypes.array.isRequired,
  toggleModal: PropTypes.bool.isRequired,
  openAddSpecialConditionModal: PropTypes.func.isRequired,
  selectedCondition: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  openDeleteSpecialConditionModal: PropTypes.func.isRequired,
  handleResetDeleteSpecialCondition: PropTypes.func.isRequired,
  handleSubmitDeleteSpecialCondition: PropTypes.func.isRequired,
};

export default withStyles(styles)(ADGMAppendix);
